var React = require('react');

function CloseMenu (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"xmlnsDefault":"http://www.w3.org/2000/svg","d":"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z","vectorEffect":"non-scaling-stroke"})));
}

CloseMenu.defaultProps = {"version":"1.2","overflow":"visible","preserveAspectRatio":"none","viewBox":"0 0 24 24","width":"31","height":"31"};

module.exports = CloseMenu;

CloseMenu.default = CloseMenu;
